/**
 * Geoscape Australia Library (GAL) Text Input Component
 * https://stackoverflow.com/questions/58791551/is-it-a-correct-way-to-extend-material-ui-components-react-typescript
 */

import { ContentCopy } from "@mui/icons-material";
import {
  Box,
  IconButton,
  StandardTextFieldProps,
  TextField,
} from "@mui/material";

export type GALTextFieldVariants = "standard" | undefined;

export interface GALTextInputProps extends StandardTextFieldProps {
  characterLimit?: number;
  variant: any; // TODO: Learn how to type this properly...
  errorText?: string; // Text message to display if there was an error
  wasTouched?: boolean; // Was the text field changed
  isError?: boolean;
  isEditing?: boolean;
  isCopyable?: boolean; // Is it possible to copy this field
  isNumberFormatted?: boolean; // Is number field formated by toLocaleString in read mode
}

export const GALTextInput: React.FunctionComponent<GALTextInputProps> = ({
  characterLimit = undefined,
  errorText = "",
  wasTouched = false,
  isError = false,
  isEditing = true,
  isCopyable = false,
  isNumberFormatted = true,
  ...props
}) => {
  // What helper text should we show
  let helperText = props.helperText;
  if (isError || errorText) {
    helperText = errorText;
  }

  let characterLimitText =
    characterLimit && props.value !== undefined
      ? `${(props.value as string).length}/${characterLimit}`
      : undefined;

  const showHelperText = helperText || characterLimitText;

  return (
    <>
      {/* Is Editing */}
      {isEditing && (
        <TextField
          {...props}
          inputProps={{ ...props.inputProps, maxLength: characterLimit }}
          helperText={
            showHelperText && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Box>{helperText}</Box>
                <Box>{characterLimitText}</Box>
              </Box>
            )
          }
          error={isError || Boolean(errorText)}
        >
          {props.children}
        </TextField>
      )}

      {/* Is Not Editing */}
      {!isEditing && (
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <TextField
            {...props}
            type="text"
            value={
              typeof props.value === "number" &&
              !isNaN(props.value) &&
              isNumberFormatted
                ? props.value.toLocaleString()
                : props.value
            }
            InputProps={{
              ...props.InputProps,
              readOnly: true,
              sx: {
                pointerEvents: "none",
                cursor: "default",
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none !important",
                },
              },
            }}
            InputLabelProps={{
              shrink: props.value !== undefined,
            }}
          />

          {isCopyable && (
            <IconButton
              onClick={(): any => {
                navigator.clipboard.writeText(
                  props.value ? (props.value as string) : ""
                );
              }}
            >
              <ContentCopy />
            </IconButton>
          )}
        </Box>
      )}
    </>
  );
};
